import PropTypes from "prop-types";
import styles from "./UnavailableProductHeader.scss";

export default function UnavailableProductHeader({ title, message }) {
  return (
    <header className={styles.header}>
      <div>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.message}>{message}</p>
      </div>
    </header>
  );
}

UnavailableProductHeader.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};
